// Contact Form Product Enquiry Handler
// Captures product information from URL parameters and populates the contact form

document.addEventListener('DOMContentLoaded', function () {
  const productEnquiryField = document.querySelector('[data-product-enquiry-field]');
  const variantEnquiryField = document.querySelector('[data-variant-enquiry-field]');
  const productEnquiryBlock = document.querySelector('[data-product-enquiry-block]');
  const variantEnquiryBlock = document.querySelector('[data-variant-enquiry-block]');

  if (!productEnquiryField) {
    return;
  }

  // Get URL parameters
  const urlParams = new URLSearchParams(window.location.search);
  const productTitle = urlParams.get('product');
  const sku = urlParams.get('sku');
  const variantTitle = urlParams.get('variant');

  // If we have product information, show and populate the fields
  if (productTitle) {
    // Set product field value with "Product: " prefix and show the block
    productEnquiryField.value = `Product: ${productTitle}`;
    if (productEnquiryBlock) {
      productEnquiryBlock.style.display = '';
    }

    // Set variant field - prioritize SKU over variant title
    if (sku) {
      variantEnquiryField.value = `SKU: ${sku}`;
      if (variantEnquiryBlock) {
        variantEnquiryBlock.style.display = '';
      }
    } else if (variantTitle && variantTitle !== 'Default Title') {
      variantEnquiryField.value = `Variant: ${variantTitle}`;
      if (variantEnquiryBlock) {
        variantEnquiryBlock.style.display = '';
      }
    }
  }
});
